import * as React from 'react';
import { Route, Routes } from "react-router-dom";
import MainLayout from './modules/MainLayout';
import Profile from './modules/profiles';
import packageJson from '../package.json';
import Dashboard from './modules/dashboard';
import MyAccount from './modules/account';
import MyAddress from './modules/address';
import MyApp from './modules/myapps';
import Devices from './modules/devices';
import Subscription from './modules/subscription';
import Redirect from './modules/redirect';
import Token from './modules/token';
import ErrorPage from './error';
import AppSecurity from './modules/security';
import { useArcAuth } from '@arcauth/react-sdk';
import { setOnUnauthorized } from './service/authEvent';

const App = () => {
  // check in build
  React.useEffect(() => {
    document.body.setAttribute('app-version', packageJson.version);
  }, []);

  // Registered once, inside ArcAuthProvider. refreshToken() resolves false when
  // the session is over; by then the SDK has already redirected to the server's
  // logoutUrl (idle timeout) or called logout(). Throwing tells the axios retry
  // layer to stop instead of retrying the request.
  const { refreshToken } = useArcAuth();
  React.useEffect(() => {
    setOnUnauthorized(async () => {
      const ok = await refreshToken();
      if (!ok) throw new Error('Token refresh failed');
    });
  }, [refreshToken]);
  return (
    <Routes>
      <Route path='error' element={<ErrorPage/>}/>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Dashboard />} />
        <Route path='redirect' element={<Redirect/>}/>
        <Route path='token' element={<Token/>}/>
        <Route path='account' element={<MyAccount />} />
        <Route path='address' element={<MyAddress />} />
        <Route path='apps' element={<MyApp />} />
        <Route path='security' element={<AppSecurity />} />
        <Route path='subscription' element={<Subscription />} />
        <Route path='devices' element={<Devices />} />
      </Route>
      <Route path='*' element={<ErrorPage/>} />
    </Routes>
  );
}

export default App;
